import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ContentCard from '../../common/ContentCard';
import UserList from '../../common/UserList';
import LoadingComponent from '../../common/LoadingComponent';
import AutoCompleteSingle from '../../common/AutoCompleteSingle';
import AddIcon from '../../icons/plus.svg';
import './styles.scss';
import {
    getResearchers,
    getPlaceDetail,
    getPlaceDetailLoading,
    assignPlacesLoading,
    unassignPlaceLoading,
} from './redux/selectors';
import {
    assignUsersToPlacesRequested,
    assigneeRequested,
    unassignUserFromPlaceRequested,
} from './redux/actions';

function ResearchersCard({
    placeId,
    researchProjectId,
    researchers,
    placeDetail,
    placeDetailLoading,
    assignUsersToPlaces,
    isAssigning,
    getAssignees,
    unassignUserFromPlace,
    isUnassigning,
}) {
    const [selectedResearcher, setResearcher] = useState(null);

    useEffect(() => {
        if (!placeDetail) {
            getAssignees(placeId);
        }
    }, []);

    const handleAddResearcher = () => {
        assignUsersToPlaces(researchProjectId, [placeId], [selectedResearcher]);
        setResearcher(null);
    };

    const handleRemoveResearcher = (researcherId) => {
        unassignUserFromPlace(researchProjectId, placeId, researcherId);
    };

    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={true} />
        </div>
    );

    const mainContent = (
        <div className="main-content custom-scroll">
            <UserList
                users={
                    placeDetail
                        ? placeDetail.assignees
                              .filter((a) => a.id)
                              .map((assignee) => ({
                                  ...assignee,
                                  fullName: assignee.name || assignee.fullName,
                              }))
                        : []
                }
                onRemoveUser={handleRemoveResearcher}
                showDeleteButton={true}
                isLoading={isUnassigning}
            />
            {placeDetailLoading ? loader : null}
        </div>
    );

    const footer = (
        <div className="row add-user">
            <AutoCompleteSingle
                id="researchers-autocomplete"
                title="Select Researcher"
                isLoading={false}
                bootstrapIcon={AddIcon}
                options={researchers}
                onSelect={(user) => {
                    setResearcher(user);
                }}
                placeholder={'Type Researcher Name'}
                disabled={
                    placeDetail &&
                    placeDetail.assignees &&
                    placeDetail.assignees.length > 0
                }
                getOptionLabel={(option) => `${option.fullName}`}
                renderOption={(option) => option.fullName}
                value={selectedResearcher}
            />
            <button
                disabled={!selectedResearcher}
                onClick={handleAddResearcher}
                className="btn btn-custom btn-sm mt-3"
            >
                {isAssigning ? loader : 'Assign'}
            </button>
        </div>
    );

    return (
        <ContentCard
            className="place-researchers"
            heading={'Assigned To'}
            content={mainContent}
            footer={footer}
            cardSize={7}
            id="places"
        />
    );
}

ResearchersCard.propTypes = {
    placeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    researchProjectId: PropTypes.number,
    researchers: PropTypes.array,
    getAssignees: PropTypes.func,
    placeDetail: PropTypes.object,
    placeDetailLoading: PropTypes.bool,
    assignUsersToPlaces: PropTypes.func,
    isAssigning: PropTypes.bool,
    unassignUserFromPlace: PropTypes.func,
    isUnassigning: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    return {
        researchers: getResearchers(state),
        placeDetail: getPlaceDetail(state, props),
        placeDetailLoading: getPlaceDetailLoading(state),
        isAssigning: assignPlacesLoading(state),
        isUnassigning: unassignPlaceLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        assignUsersToPlaces: (researchProjectId, placeIds, researchers) =>
            dispatch(
                assignUsersToPlacesRequested(
                    researchProjectId,
                    placeIds,
                    researchers,
                ),
            ),
        getAssignees: (placeId) => dispatch(assigneeRequested(placeId)),
        unassignUserFromPlace: (researchProjectId, placeId, researcherId) =>
            dispatch(
                unassignUserFromPlaceRequested(
                    researchProjectId,
                    placeId,
                    researcherId,
                ),
            ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResearchersCard);
